import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Directive,
    ElementRef,
    Input,
    OnInit,
    Renderer,
    Renderer2
} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../../autenticacion/servicios/auth.service';
import {ConsumerService} from '../../../recursos/servicio/consumer.service';
import {UtilConfig} from '../../../../autenticacion/servicios/UtilConfig';
import {Router} from '@angular/router';
import * as moment from 'moment';
import {MatSnackBar} from '@angular/material';
import {debounceTime, map, startWith} from "rxjs/operators";
import {BsDatepickerConfig} from "ngx-bootstrap/datepicker";
import {Ide} from "../recursos/modelo/ide";
import {Emi} from "../recursos/modelo/Emi";
import {Rec} from "../recursos/modelo/Rec";
import {WebServices} from "../../../recursos/modelo/consumerModel/web-services.enum";
import {BillingConfiguration} from "../../seguridad/emisor/recursos/modelo/emisor-configuration";
import {TipoDocumento} from "../../seguridad/emisor/recursos/modelo/tipo-documento.enum";
import {Observable} from "rxjs/Observable";
import {leftPad} from "../../../../../pipes/utils/utils";
import {Crt} from "../recursos/modelo/crt";
import {LogEmisor} from "../../transaccion/logEmisorTmp/recursos/modelo/LogEmisor";
import { getDocumentInfo } from '../util/util-type-name';

declare var $: any;
declare var swal: any;

// tslint:disable-next-line:directive-selector
@Directive({selector: '[myFocusRetencion]'})
// tslint:disable-next-line:directive-class-suffix
export class FocusDirectiveRetencion implements OnInit {

    // tslint:disable-next-line:no-input-rename
    @Input('myFocusRetencion') isFocused: boolean;

    constructor(private hostElement: ElementRef, private renderer: Renderer) {
    }

    ngOnInit() {
        if (this.isFocused) {
            this.renderer.invokeElementMethod(this.hostElement.nativeElement, 'focus');
        }
    }
}

@Component({
    selector: 'app-retencion',
    templateUrl: './view/retencion.component.html',
    styleUrls: ['./css/retencion.component.scss'],
    providers: [AuthService, ConsumerService],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RetencionComponent implements OnInit {

    RUC = '6';
    DND = '0';
    DNI = '1';
    CARNET_EXTRAJERIA = '4';
    PASAPORTE = '7';
    /**
     * PARAMETROS DE CONFIGURACION GENERAL
     *
     */
    bsConfig: Partial<BsDatepickerConfig>;
    usuarioSession: any;
    additionalDataPermanent = [];
    additionalDataTmp = [];
    tipoDoc = '20';
    IGV = 18.0;
    colorTheme = 'theme-dark-blue';
    step = 0;
    loadingConsultas = [
        {
            modulo: 'Cargando Series',
            cargando: true
        }
    ];
    loading_documento = false;
    loading_popup = false;
    popup_text = '';
    docType: any[] = [];
    documentType: any[] = [];
    monedaType: any[] = [];
    document: any = {value: '01', label: 'Factura Electronica'};
    typeDocument: any = {value: this.RUC, label: 'RUC'};
    tipMonedaDocRelacionado: any = {value: 'PEN', label: 'Soles'};
    template_retencion = this.nuevaRetencion();
    options: String[] = [];
    filteredOptionsSerie: Observable<String[]>;
    observation = '';
    formRetention: FormGroup;
    formComprobante: FormGroup;
    vld_serie: FormControl;
    vld_rucProveedor: FormControl;
    vld_observation: FormControl;
    vld_fecha_vencimiento: FormControl;
    vld_nameProveedor: FormControl;
    vld_telefonoProveedor: FormControl;
    vld_correoProveedor: FormControl;
    vld_direccionProveedor: FormControl;

    formAdditionalPermanent: FormGroup;
    formAdditionalTemp: FormGroup;
    vld_additionalTempKey: FormControl;
    vld_additionalTempValue: FormControl;
    vld_additionalPermanentKey: FormControl;
    vld_additionalPermanentValue: FormControl;
    loadingAddDataAditional = false;
    removeAdditionalPermanent = false;

    keyTemp = '';
    valueTemp = '';
    keyPermanent = '';
    valuePermanent = '';
    preview = false;
    totalLetter = '';
    tamanoIdDocNumber = '11';
    mensaje = '';
    error = false;

    popupComprobante = false;

    newSerie = '';
    newCorrelativo = '';
    newImporteTotalPagarNeto = '0.00';
    newImporteTotalPagarNetoSoles = '0.00';

    tasaRetencion = '3.00';
    newTasaRetencion = '3.00';
    newTasaCambio = '1.00';
    newImporteTotalDocRelacionado = '';
    newImporteRetenido = '0.00';
    newImporteRetenidoSoles = '0.00';
    newNumPago = '';
    newFechaEmision;

    vld_newSerie: FormControl;
    vld_newCorrelativo: FormControl;
    vld_newFechaEmision: FormControl;
    vld_newImporteTotalDocRelacionado: FormControl;
    vld_newTasaCambio: FormControl;
    vld_newNumPago: FormControl;
    importePagadoTotal = 0.00;
    importeTotalRetenido = 0.00;
    today = new Date();

    showCreationSummary = false;
    messageCreation = '';
    logSeleccionado = new LogEmisor();
    cargaDocumentos = false;

    constructor(private util: UtilConfig,
                private cd: ChangeDetectorRef,
                private fb: FormBuilder,
                private router: Router,
                private renderer: Renderer2,
                private consumerService: ConsumerService,
                private snackBar: MatSnackBar) {
        this.createFormControls();
        this.createFormRetention();
        this.createFormComprobante();
        this.usuarioSession = this.util.getCurrentUser();
        this.IGV = this.usuarioSession.customer.igv || 18.0;
        this.bsConfig = Object.assign({}, {
            containerClass: this.colorTheme,
            showWeekNumbers: false,
            dateInputFormat: 'YYYY-MM-DD',
            maxDate: moment().toDate()
        });

        this.docType.push({value: this.RUC, label: 'RUC'});

        this.filteredOptionsSerie = this.vld_serie.valueChanges
            .pipe(
                startWith(''), debounceTime(500),
                map(value => {
                    return (value) ? this._filter(value) : this.options.slice();
                }));

        this.documentType = [];
        this.documentType.push({label: 'Factura Electronica', value: '01'});
        this.documentType.push({label: 'Boleta Electronica', value: '03'});


        this.monedaType = [];
        this.monedaType.push({label: 'Soles', value: 'PEN'});
        this.monedaType.push({label: 'Dolares estadounidenses', value: 'USD'});

        this.additionalDataPermanent = [];
    }


    ngOnInit(): void {
        this.getSeries();
        this.getAdditionalDataPermanent();
    }

    getAdditionalDataPermanent() {
        const body = JSON.stringify({
            customer: {
                ruc: this.util.getCurrentUser().customer.ruc,
                id: this.util.getCurrentUser().customer.id
            }
        });
        this.consumerService.post(WebServices.URL_GET_ADDITIONAL_DATA_PERMANENT, body).subscribe(result => {
            let list = result['additionalDataPermanents'];
            list.forEach((item) => {
                    if (item.documentType == 'RETENTION') {
                        this.additionalDataPermanent.push({
                            id: item.id,
                            tituloAdicional: item.tituloAdicional,
                            valorAdicional: item.valorAdicional
                        });
                    }
                }
            );
        }, err => {
            console.log('ERROR' + err);
            swal({
                title: 'Error',
                text: UtilConfig.DEFAULT_MESSAGE_ERROR,
                type: 'error',
                showCancelButton: false,
                confirmButtonText: 'Proceder!'
            });
        });
    }

    setStep(index: number) {
        this.step = index;
    }

    createFormControls() {
        this.vld_serie = new FormControl({value: ''}, [Validators.required]);
        this.vld_rucProveedor = new FormControl({value: ''}, [Validators.required]);
        this.vld_fecha_vencimiento = new FormControl({}, [Validators.required]);
        this.vld_observation = new FormControl({}, [Validators.nullValidator]);
        this.vld_nameProveedor = new FormControl({}, [Validators.nullValidator]);
        this.vld_telefonoProveedor = new FormControl({}, [Validators.nullValidator]);
        this.vld_correoProveedor = new FormControl({}, [Validators.nullValidator]);
        this.vld_direccionProveedor = new FormControl({}, [Validators.nullValidator]);

        this.vld_additionalTempKey = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_additionalTempValue = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_additionalPermanentKey = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_additionalPermanentValue = new FormControl({value: ''}, [Validators.nullValidator]);
    }

    createFormRetention() {
        this.formRetention = this.fb.group({
            'serie': this.vld_serie,
            'fechaEmision': this.vld_fecha_vencimiento,
            'observacion': this.vld_observation,
            'rucProveedor': this.vld_rucProveedor,
            'nameProveedor': this.vld_nameProveedor,
            'telefonoProveedor': this.vld_telefonoProveedor,
            'correoProveedor': this.vld_correoProveedor,
            'direccionProveedor': this.vld_direccionProveedor,
        });

        this.formAdditionalPermanent = this.fb.group({
            'key': this.vld_additionalPermanentKey,
            'value': this.vld_additionalPermanentValue,
        });
        this.formAdditionalTemp = this.fb.group({
            'key': this.vld_additionalTempKey,
            'value': this.vld_additionalTempValue,
        });
    }


    createFormComprobante() {

        this.vld_newSerie = new FormControl({value: ''}, [Validators.required]);
        this.vld_newCorrelativo = new FormControl({value: ''}, [Validators.required]);
        this.vld_newFechaEmision = new FormControl({value: ''}, [Validators.required]);
        this.vld_newImporteTotalDocRelacionado = new FormControl({value: ''}, [Validators.required]);
        this.vld_newTasaCambio = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_newNumPago = new FormControl({value: ''}, [Validators.required]);


        this.formComprobante = this.fb.group({
            'newSerie': this.vld_newSerie,
            'newCorrelativo': this.vld_newCorrelativo,
            'newFechaEmision': this.vld_newFechaEmision,
            'newImporteTotalDocRelacionado': this.vld_newImporteTotalDocRelacionado,
            'newTasaCambio': this.vld_newTasaCambio,
            'newNumPago': this.vld_newNumPago,
        });
    }


    private _filter(value: string): String[] {
        if (value) {
            const filterValue = value.toLowerCase();
            return this.options.filter(option => option.toLowerCase().includes(filterValue));
        }
    }

    cargarTypeDocuments(docType: any) {
        this.typeDocument = docType;
        this.template_retencion.cRetencion.pro.tipoDocId = docType.value;
        this.template_retencion.cRetencion.pro.numeroDocId = '';
        this.template_retencion.cRetencion.pro.razonSocial = '';
        this.template_retencion.cRetencion.pro.telefono = '';
        this.template_retencion.cRetencion.pro.correoElectronico = '';
        this.template_retencion.cRetencion.pro.direccion = '';
        this.adaptarValidacion();
    }

    setTypeDocuments(docType: any, i: number) {
        this.template_retencion.cRetencion.drt[i].tipDocRelacionado = docType.value;
    }

    nuevaRetencion() {
        this.additionalDataTmp = [];
        let template_retencion: any = {
            cRetencion: {
                ide: new Ide(),
                emi: new Emi(this.util.getCurrentUser().customer.ruc, this.util.getCurrentUser().customer.nombre, '6'),
                crt: new Crt(),
                pro: new Rec(),
                drt: [],
                adi: []
            }
        };

        template_retencion.cRetencion.pro.tipoDocId = '6';
        template_retencion.cRetencion.ide.codTipoDocumento = null;
        template_retencion.cRetencion.ide.formaPago = null;
        template_retencion.cRetencion.ide.tipoMoneda = null;

        template_retencion.cRetencion.emi.ubigeo = this.util.getCurrentUser().customer.ubigeo;
        const direccion = ((this.util.getCurrentUser().customer.tipoVia != null) ? this.util.getCurrentUser().customer.tipoVia : '') + ' ' +
            ((this.util.getCurrentUser().customer.nombreVia != null) ? this.util.getCurrentUser().customer.nombreVia : '') + ' ' +
            ((this.util.getCurrentUser().customer.numero != null) ? this.util.getCurrentUser().customer.numero : '') + ' - ' +
            ((this.util.getCurrentUser().customer.interior != null) ? this.util.getCurrentUser().customer.interior : '') + ',' +
            ((this.util.getCurrentUser().customer.codigoZona != null) ? this.util.getCurrentUser().customer.codigoZona : '') + ' ' +
            ((this.util.getCurrentUser().customer.tipoZona != null) ? this.util.getCurrentUser().customer.tipoZona : '');
        template_retencion.cRetencion.emi.direccion = direccion;
        return template_retencion;
    }

    getSeries() {
        const body = JSON.stringify({
            customer: {
                ruc: this.util.getCurrentUser().customer.ruc,
                id: this.util.getCurrentUser().customer.id
            }
        });
        this.loadingConsultas[0].cargando = true;
        this.consumerService.update(WebServices.URL_GET_SERIES, body).subscribe(x => {
            this.loadingConsultas[0].cargando = false;
            this.cd.markForCheck();
            this.cd.detectChanges();
            let emisorConfig: BillingConfiguration[] = x['billingConfigurationsList'];
            emisorConfig = emisorConfig.filter(xx => xx.documentType === TipoDocumento.RETENTION);
            if (emisorConfig.length === 0) {
                swal({
                    title: 'Obligatorio',
                    text: 'Debe configurar al menos una serie para la boleta del emisor ' +
                        this.util.getCurrentUser().customer.nombre + ' - ' + this.util.getCurrentUser().customer.ruc,
                    type: 'warning',
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 3000
                });
                setTimeout(() => {
                    const filtro: any = {};
                    filtro.busqueda = this.util.getCurrentUser().customer.ruc;
                    $('ul#slide-out').removeClass('open');
                    $('i.cerrarAleta').removeClass('open');
                    $('.closePopupNotaDebito').click();
                    this.router.navigate(['/content', {outlets: {'second': ['emisor', this.util.getCurrentUser().customer.id]}}]);
                }, 3000);
            } else {
                for (const ec of emisorConfig) {
                    this.options.push(ec.serialNumber);
                }
                if (this.options.length === 1) {
                    this.vld_serie.setValue(this.options[0]);
                }

            }
        }, err => {
            this.loadingConsultas[0].cargando = false;
            this.cd.markForCheck();
            this.cd.detectChanges();
            this.util.abrirModalErrorParaServicios(err, 'Error', this.router);
        });
    }


    removeAditionalDataPermanent(pos, item) {
        const body = JSON.stringify({
            additionalDataPermanent: item
        });
        this.removeAdditionalPermanent = true;
        this.consumerService.post<any>(WebServices.URL_DELETE_ADDITIONAL_DATA_PERMANENT, body).subscribe(result => {
            this.additionalDataPermanent.splice(pos, 1);
            this.removeAdditionalPermanent = false;
            this.cd.markForCheck();
            this.cd.detectChanges();
        }, err => {
            this.removeAdditionalPermanent = false;
            console.log('ERROR' + err);
        });
    }

    removeAditionalDataTmp(pos) {
        this.additionalDataTmp.splice(pos, 1);
    }

    addAdditionalDataTmp() {
        if (this.keyTemp == '' || this.valueTemp == '') {
            this.snackBar.open('Debe completar los campos', null, {duration: 2000});
            return false;
        }

        this.additionalDataTmp.push({
            tituloAdicional: this.keyTemp,
            valorAdicional: this.valueTemp
        });
        this.keyTemp = '';
        this.valueTemp = '';
    }

    addAdditionalDataPermanent() {
        if (this.keyPermanent == '' || this.valuePermanent == '') {
            this.snackBar.open('Debe completar los campos', null, {duration: 2000});
            return false;
        }

        const body = JSON.stringify({
            additionalDataPermanent: {
                id: this.util.getCurrentUser().customer.id,
                documentType: 'RETENTION',
                tituloAdicional: this.keyPermanent,
                valorAdicional: this.valuePermanent,
                logUsernameRegistro: this.util.getCurrentUser().username
            },
            customer: {
                id: this.util.getCurrentUser().customer.id,
                ruc: this.util.getCurrentUser().customer.ruc,
            }
        });
        this.loadingAddDataAditional = true;
        this.consumerService.post<any>(WebServices.URL_SAVE_ADDITIONAL_DATA_PERMANENT, body).subscribe(result => {
            let additionalDataPermanent = result['additionalDataPermanent'];
            this.loadingAddDataAditional = false;
            this.additionalDataPermanent.push({
                tituloAdicional: additionalDataPermanent.tituloAdicional,
                valorAdicional: additionalDataPermanent.valorAdicional
            });
        }, err => {
            this.loadingAddDataAditional = false;
            console.log('ERROR' + err);
        });

        this.keyPermanent = '';
        this.valuePermanent = '';

    }

    onSubmitRetencion(tipo) {
        this.error = false;
        this.mensaje = '';
        if (this.formRetention.valid) {
            this.generarDocumentoRetencion(tipo);
        } else {
            swal(
                'Campos obligatorios',
                'Debe completar todo los campos con (*)',
                'error'
            );
        }
    }

    getTotalLetter() {
        const body = JSON.stringify({
            montoPendientePago: this.importeTotalRetenido,
            currency: 'PEN',
        });
        this.consumerService.post(WebServices.URL_GET_TOTAL_LETTER, body).subscribe(result => {
            this.totalLetter = result['responseMessage'];
            this.cd.markForCheck();
            this.cd.detectChanges();
        }, err => {
            this.cd.markForCheck();
            this.cd.detectChanges();
            console.log('ERROR' + err);
        });
    }

    generarPreview() {
        this.getTotalLetter();
        this.generatePreCreateDocument();
        this.preview = true;

    }

    generarDocumentoRetencion(tipo) {
        this.generatePreCreateDocument();

        this.template_retencion = this.util.removeAllBlankOrNull_asString(this.template_retencion);
        const req: any = {
            retentionDocumentTemplate: {
                cRetencion: this.template_retencion.cRetencion
            },
            documentType: this.tipoDoc,
            customer: {
                ruc: this.util.getCurrentUser().customer.ruc
            }
        };

        this.loading_documento = true;
        this.consumerService.create(WebServices.URL_GENERAR_DOCUMENTOS, req)
            .subscribe(result => {
                this.loading_documento = false;
                this.cd.markForCheck();
                this.cd.detectChanges();
                if (result.codigo !== 1) {
                    swal(
                        'No se pudo crear la retención',
                        result.mensaje,
                        'error'
                    );

                } else {
                    this.messageCreation = result.mensaje;
                    this.template_retencion.cRetencion.ide.numeracion = getDocumentInfo(result.mensaje, 'R');
                    this.showCreationSummary = true;
                    this.getIdByName(this.template_retencion.cRetencion.ide.numeracion);
                    this.cd.markForCheck();
                    this.cd.detectChanges();
                }
                this.setStep(0);
                this.preview = false;
                this.cd.markForCheck();
                this.cd.detectChanges();
            }, err => {
                this.loading_documento = false;
                this.util.abrirModalErrorParaServicios(err, 'No se pudo crear el documento', this.router);
            });
    }

    getIdByName(name) {
        const body = JSON.stringify({
            customer: {
                ruc: this.util.getCurrentUser().customer.ruc,
                id: this.util.getCurrentUser().customer.id
            },
            filename: name,
            documentType: 'RETENTION'
        });
        this.cargaDocumentos = true;
        this.consumerService.update(WebServices.URL_GET_ID_DOCUMENT, body).subscribe(result => {
            this.cargaDocumentos = false;
            this.logSeleccionado.id = result['idDocument'];
            this.logSeleccionado.linkRequestPSE = this.util.URL_WS_BACKEND + WebServices.URL_GET_ARCHIVO_LOG_EMISOR + '?log.id=' + this.logSeleccionado.id + '&tipoDescarga=PSE&authorization=' + this.util.getJwtToken();
            this.logSeleccionado.linkRequestXML = this.util.URL_WS_BACKEND + WebServices.URL_GET_ARCHIVO_LOG_EMISOR + '?log.id=' + this.logSeleccionado.id + '&tipoDescarga=XML&authorization=' + this.util.getJwtToken();
            this.logSeleccionado.linkResponseCDR = this.util.URL_WS_BACKEND + WebServices.URL_GET_ARCHIVO_LOG_EMISOR + '?log.id=' + this.logSeleccionado.id + '&tipoDescarga=CDR&authorization=' + this.util.getJwtToken();
            this.logSeleccionado.linkResponsePDF = this.util.URL_WS_BACKEND + WebServices.URL_GET_ARCHIVO_LOG_EMISOR + '?log.id=' + this.logSeleccionado.id + '&tipoDescarga=PDF&authorization=' + this.util.getJwtToken();

            this.cd.markForCheck();
            this.cd.detectChanges();
        }, err => {
            this.cargaDocumentos = false;
            this.cd.markForCheck();
            this.cd.detectChanges();
            this.util.abrirModalErrorParaServicios(err, 'Error', this.router);
        });
    }

    private generatePreCreateDocument() {
        this.generarADI();
    }

    generarADI() {
        this.template_retencion.cRetencion.adi = [];

        // ADDITIONAL
        this.armarAdditionalData();
    }

    armarAdditionalData() {

        if (this.observation.trim() != '') {
            this.template_retencion.cRetencion.adi.push(
                {
                    tituloAdicional: 'Observaciones',
                    valorAdicional: this.observation
                });
        }
        if (this.observation.trim() != '') {
            this.template_retencion.cRetencion.adi.push(
                {
                    tituloAdicional: '@@montoEnLetras',
                    valorAdicional: this.totalLetter
                });
        }

        if (this.additionalDataPermanent != null && this.additionalDataPermanent.length > 0) {
            this.additionalDataPermanent.forEach(item => {
                this.template_retencion.cRetencion.adi.push(
                    {
                        tituloAdicional: item.tituloAdicional,
                        valorAdicional: item.valorAdicional
                    });
            });
        }

        if (this.additionalDataTmp != null && this.additionalDataTmp.length > 0) {
            this.additionalDataTmp.forEach(item => {
                this.template_retencion.cRetencion.adi.push(
                    {
                        tituloAdicional: item.tituloAdicional,
                        valorAdicional: item.valorAdicional
                    });
            });
        }
    }

    deshabilitarBoton() {
        if (!this.formRetention.valid ||
            this.template_retencion.cRetencion.ide.numeracion == '' ||
            this.template_retencion.cRetencion.pro.numeroDocId.length != 11 ||
            this.template_retencion.cRetencion.pro.razonSocial == '' ||
            this.template_retencion.cRetencion.pro.direccion == '' ||
            this.template_retencion.cRetencion.drt.length == 0) {
            return true;
        }

        return false;
    }

    adaptarValidacion() {
        if (this.typeDocument.value === '0') {
            this.tamanoIdDocNumber = '15';
            $('.numeroDocumentoValidator').attr('class', 'col-md-4 numeroDocumentoValidator dnd_after');
        }
        if (this.typeDocument.value === '1') {
            this.tamanoIdDocNumber = '8';
            $('.numeroDocumentoValidator').attr('class', 'col-md-4 numeroDocumentoValidator dni_after');
        }

        if (this.typeDocument.value === '4') {
            this.tamanoIdDocNumber = '15';
            $('.numeroDocumentoValidator').attr('class', 'col-md-4 numeroDocumentoValidator carnetExtrajenria_after');

        }
        if (this.typeDocument.value === '6') {
            this.tamanoIdDocNumber = '11';
            $('.numeroDocumentoValidator').attr('class', 'col-md-4 numeroDocumentoValidator ruc_after');
        }

        if (this.typeDocument.value === '7') {
            this.tamanoIdDocNumber = '15';
            $('.numeroDocumentoValidator').attr('class', 'col-md-4 numeroDocumentoValidator pasaporte_after');
        }
        this.cd.markForCheck();
        this.cd.detectChanges();
    }

    public verificarRuc() {
        if (this.template_retencion.cRetencion.pro.numeroDocId != "") {
            // LLAMADO AL SERVICIO
            this.consumerService.post(WebServices.URL_GET_MASTER_EMISOR, {customer: {ruc: this.template_retencion.cRetencion.pro.numeroDocId}})
                .subscribe(result => {
                    //DEFAULT DATA
                    var emisor = result["customer"];
                    this.template_retencion.cRetencion.pro.razonSocial = emisor.nombre;
                    this.template_retencion.cRetencion.pro.correoElectronico = emisor.correo;
                    const direccion = ((emisor.tipoVia != null) ? emisor.tipoVia : '') + ' ' +
                        ((emisor.nombreVia != null) ? emisor.nombreVia : '') + ' ' +
                        ((emisor.numero != null) ? emisor.numero : '') + ' - ' +
                        ((emisor.interior != null) ? emisor.interior : '') + ',' +
                        ((emisor.codigoZona != null) ? emisor.codigoZona : '') + ' ' +
                        ((emisor.tipoZona != null) ? emisor.tipoZona : '');
                    this.template_retencion.cRetencion.pro.direccion = direccion;
                }, err => {
                    this.util.abrirModalErrorParaServicios(err, "No se pudo consultar al emisor", this.router)
                });
        }
    }

    divAgregarNewComprobante() {
        this.newImporteTotalDocRelacionado = '';
        this.newCorrelativo = '';
        this.newSerie = '';
        this.newFechaEmision = '';
        this.newImporteTotalDocRelacionado = '';
        this.newNumPago = '';
        this.newImporteTotalPagarNeto = '';
        this.newTasaCambio = '1.0';
        this.newImporteTotalPagarNetoSoles = '';
        this.tipMonedaDocRelacionado = {value: 'PEN', label: 'Soles'};
        this.tasaRetencion = '3.00';
        this.newImporteRetenidoSoles = '';
        this.newImporteRetenido = '';


        this.popupComprobante = true;
    }

    cerrarPopupComprobante() {
        this.popupComprobante = false;
    }

    agregarNewComprobante() {
        this.popupComprobante = false;
        if (this.template_retencion.cRetencion.drt == null) {
            this.template_retencion.cRetencion.drt = [];
        }
        this.template_retencion.cRetencion.drt.push({
            "numeroItem": this.template_retencion.cRetencion.drt.length + 1,
            "tipDocRelacionado": this.document.value,
            "numDocRelacionado": this.newSerie + '-' + this.newCorrelativo,
            "fecEmisionDocRelacionado": moment(this.newFechaEmision).format('YYYY-MM-DD'),
            "importeTotalDocRelacionado": this.newImporteTotalDocRelacionado,
            "tipMonedaDocRelacionado": this.tipMonedaDocRelacionado.value,
            "fechaPago": moment(this.today).format('YYYY-MM-DD'),
            "numPago": this.newNumPago,
            "importePagoSinRetencion": this.newImporteTotalDocRelacionado,
            "monedaPagoSinRetencion": this.tipMonedaDocRelacionado.value,
            "importeRetenido": this.newImporteRetenidoSoles,
            "monedaImporteRetenido": "PEN",
            "fechaRetencion": moment(this.today).format('YYYY-MM-DD'),
            "importeTotalPagarNeto": this.newImporteTotalPagarNetoSoles,
            "monedaMontoNetoPagado": "PEN",
            "monedaRefTipCambio": this.tipMonedaDocRelacionado.value,
            "monedaObjTipCambio": "PEN",
            "factorAplicado": this.newTasaCambio,
            "fechaTipCambio": moment(this.today).format('YYYY-MM-DD'),
            "tasaRetencion": this.tasaRetencion
        });
        this.calcularTotal();
        this.cd.markForCheck();
        this.cd.detectChanges();
    }

    changeTypeCurrency(item) {
        this.tipMonedaDocRelacionado = item;
        if (item.value == 'PEN') {
            this.newTasaCambio = '1.00';
        }
        this.calculate();
    }

    changeDocumentType(item) {
        this.document = item;
        this.cd.markForCheck();
        this.cd.detectChanges();
        this.calculate();
    }

    changeNewTasaRetencion(item) {
        this.newTasaRetencion = item;
        this.calculate();
    }

    calculate() {
        if (this.newImporteTotalDocRelacionado.trim() != '') {
            this.newImporteRetenido = (parseFloat(this.newImporteTotalDocRelacionado) * parseFloat(this.newTasaRetencion) / 100).toFixed(2);
            this.newImporteTotalPagarNeto = (parseFloat(this.newImporteTotalDocRelacionado) - parseFloat(this.newImporteRetenido)).toFixed(2);
            this.newImporteRetenidoSoles = (parseFloat(this.newImporteRetenido) * parseFloat(this.newTasaCambio)).toFixed(2);
            this.newImporteTotalPagarNetoSoles = (parseFloat(this.newImporteTotalPagarNeto) * parseFloat(this.newTasaCambio)).toFixed(2);
        }
    }

    calcularTotal() {
        this.importePagadoTotal = 0;
        this.importeTotalRetenido = 0;
        this.template_retencion.cRetencion.drt.forEach((item) => {
            this.importePagadoTotal = this.importePagadoTotal + parseFloat(item.importeTotalPagarNeto);
            this.importeTotalRetenido = this.importeTotalRetenido + parseFloat(item.importeRetenido);
        });
        this.template_retencion.cRetencion.crt.importeTotalPagado = this.importePagadoTotal.toFixed(2);
        this.template_retencion.cRetencion.crt.importeTotalRetenido = this.importeTotalRetenido.toFixed(2);
        this.getTotalLetter();
    }

    removeItem(pos) {
        this.template_retencion.cRetencion.drt.splice(pos, 1);
        this.calcularTotal();
    }


    private resetDocument(event) {
        this.template_retencion = this.nuevaRetencion();
        this.showCreationSummary = false;
        this.preview = false;
        this.cd.markForCheck();
        this.cd.detectChanges();
    }

    disabledAddVoucher() {
        if (this.newSerie.trim() == '') {
            return true;
        }
        if (this.newCorrelativo.trim() == '' || this.newCorrelativo.length != 8) {
            return true;
        }
        if (this.newFechaEmision == null) {
            return true;
        }
        if (this.newImporteTotalDocRelacionado.trim() == '') {
            return true;
        }
        if (this.newNumPago.trim() == '') {
            return true;
        }
        return false;
    }

    setLeftPadCorrelative() {
        this.newCorrelativo = leftPad(this.newCorrelativo, 8, '0');
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/retencion/retencion.component.ts